import React from 'react';
import { Tabs } from 'antd';
import cx from 'classnames';

import { CATEGORY_TYPE, CATEGORY_TYPE_TEXT } from '../../../../../constants/service/app/categoryConstants';
import './CategoryListTabBox.scss';

const CategoryListTabBox = (props) => {
  const { className, title, categoryTabType, setCategoryTabType, children } = props;

  const items = [
    {
      key: String(CATEGORY_TYPE.GENERAL),
      label: CATEGORY_TYPE_TEXT[CATEGORY_TYPE.GENERAL],
      children: children,
    },
    {
      key: String(CATEGORY_TYPE.EMPHASIS),
      label: CATEGORY_TYPE_TEXT[CATEGORY_TYPE.EMPHASIS],
      children: children,
    },
  ];

  return (
    <div className={cx('category-list-tab-box-wrap', className)}>
      <div className="main-title-wrap">{title}</div>
      <Tabs
        defaultActiveKey={String(CATEGORY_TYPE.GENERAL)}
        activeKey={categoryTabType}
        type="card"
        onChange={(activeKey) => setCategoryTabType(activeKey)}
        items={items}
      />
    </div>
  );
};

export default CategoryListTabBox;
